module.exports = __webpack_public_path__ + "static/one-a23b1b9581190fbb4cc57be1b7c19bbf.png";